export enum LogLevel {
  DEBUG = 'debug',
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error',
}

export enum EnvironmentType {
  SANDBOX = 'sandbox',
  PRODUCTION = 'production',
  UAT = 'uat',
  LOCAL = 'local',
}

export interface Environment {
  production: boolean;
  type: EnvironmentType;
  apiUrl: string;
  appName: string;
  version: string;
  debug: boolean;
  logLevel: LogLevel;
  baseRedirectUrl: string;
  // sardine configuration
  sardineHost: string;
  sardineClientId: string;
  // api http requests configuration
  apiMaxRetryAttempts: number;
  apiBaseDelayMs: number;
  // allowed frame ancestors domains
  allowedFrameAncestors: string[];
  // sentry configuration
  sentry: {
    dsn: string;
    environment: string;
    enabled: boolean;
  };
  // posthog feature flags, shared with the portal
  featureFlagConfig: {
    url: string;
    key: string;
  };
  featureFlags: {
    /** Hides the apply-to-Sokin banner on the payment-links-lite thank-you screen. */
    PaymentLinkLiteHideMarketingBanner: string;
    /** Offers Pay by Bank in the checkout. Off removes it from the payment methods. */
    PayByBankEnabled: string;
  };
  sdkConfig: {
    angularAppBaseUrl: string;
    b2bAPIBaseUrl: string;
    b2bAPIBaseUrlDotCom: string;
    allowedOrigins: string[];
  };
}
